import { withTextComponent } from '@updater-legacy/components/custom-element';
import dateFormat from 'dateformat';

const attributes = ['format', 'value'];

export default class DateFormatter extends withTextComponent() {
  static observedAttributes = attributes;

  static reflectedAttributes = attributes;

  updated({ format, value }) {
    if (value) {
      this.textContent = dateFormat(value, format);
    }
  }
}

customElements.define('upd-date-formatter', DateFormatter);
